import type { FieldValues } from 'react-hook-form';
import type { QuestionnaireResultResponse, TemplateResponseCore, TemplateResultResponse } from '@gcv/shared';

import { getModifiedDateText } from './format.util';

/**
 * Helper function to get the flat form values of custom field responses
 */
export const getCustomFieldsFormValues = (
  templateResult: TemplateResultResponse | QuestionnaireResultResponse | null,
  template: TemplateResponseCore | null
): FieldValues => {
  const updatedValues = {} as FieldValues;
  if (templateResult?.custom_requirement_result?.length) {
    for (const customResult of templateResult.custom_requirement_result) {
      if (customResult.custom_fields?.responses) {
        Object.entries(customResult.custom_fields.responses).forEach((entry) => {
          if (template?.custom_requirements?.[customResult.requirement_id]?.custom_section?.repeatable) {
            updatedValues[`${entry[0]}_${customResult.id}`] = entry[1];
          } else {
            updatedValues[entry[0]] = entry[1];
          }
        });
      }
    }
  }
  return updatedValues;
};

/**
 * Helper function to get latest modified date across all custom fields by looking at the date updated of each since we don't always update the template result date updated
 */
export const getCustomFieldsLastModifiedDateText = (
  templateResult: TemplateResultResponse | QuestionnaireResultResponse | null
): string => {
  const lastModifiedDate =
    templateResult?.custom_requirement_result
      .map((r) => r.date_updated)
      .sort((a, b) => (a > b ? -1 : 1))[0] ?? templateResult?.date_updated;
  return lastModifiedDate ? getModifiedDateText(lastModifiedDate) : '--';
};
